/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { EventEmitter } from '@angular/core';
import { StaticModal } from '@support/shared/widgets/interfaces/static-modal.interface';
import { TmoButton } from '@support/shared/widgets/interfaces/button.interface';

export class NavbarModal implements StaticModal {
  /**
   * Stores the text for the header file
   */
  public headerText: string;
  /**
   * Stores the text for the body file
   */
  public bodyText: string;
  /**
   * Stores the boolean value to disable dismiss
   */
  public disableDismiss: boolean;
  /**
   * Stores the boolean value to disable Esc
   */
  public disableEsc: boolean;
  /**
   * Stores the button id, name, class , type for TmoButton from button.interface
   */
  public buttons: TmoButton[];
  /**
   * Creates an instance of toggleModalEmitter of type EventEmitter
   */
  public toggleModalEmitter: EventEmitter<object>;
  /**
   * Stores the boolean value for DismissableMiask
   */
  public dismissableMask: boolean;
  /**
   * Stores the string values for headertext
   */
  public headertext: string;
  /**
   * Stores the string values for BodytextConsumer
   */
  public bodyTextConsumer: string;

  constructor() {
    this.headerText = '';
    this.bodyText = '';
    this.disableDismiss = false;
    this.disableEsc = false;
    this.buttons = [
      {
        id: 'cancel',
        type: 'cancel',
        name: 'Cancel',
        class: 'btn btn-secondary',
      },
      {
        id: 'save&Continue',
        type: 'submit',
        name: 'Continue',
        class: 'btn btn-primary',
      },
    ];
    this.toggleModalEmitter = new EventEmitter();
    this.dismissableMask = false;
  }
}
